import { removeHttpProtocol } from '@linkie/shared';
import { isPreviewRoute } from './is-preview-route';

/**
 * True only on the Linkie app itself — the signed-in surface plus the auth screens in front
 * of it — and never on a page a visitor sees.
 *
 * Deliberately stricter than `!isPublicPageRoute()`. That helper treats HOME_URL as "not a
 * custom domain", but `routes.tsx` renders the public page for `/` on *any* host that is not
 * CLIENT_URL, and `usePlaygroundShare` links previews at `HOME_URL/:username`. Anything that
 * must never reach a page owner's audience — the support chat — keys off this instead, so a
 * host we forgot about fails closed.
 */
export const isAppSurface = (pathname?: string): boolean =>
  window.location.host === removeHttpProtocol(process.env.CLIENT_URL!) && !isPreviewRoute(pathname);
